var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "checkdevicepage_div" },
    [
      _c("van-loading", { staticClass: "checkdevicepage_loading" }, [
        _vm._v("加载中..."),
      ]),
      _c("div", {
        staticClass: "checkdevicepage_showdeviceiddiv",
        on: { dblclick: _vm.showDeviceId },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }